// RemoveButton.js
// Component for a Remove Button with Confirmation

// Imports
import React from 'react';
import { Tooltip, Button, Position, Popover, PopoverInteractionKind, Classes } from '@blueprintjs/core';
import PropTypes from 'prop-types';

// Component Class
// Renders a remove button which enforces confirmation
class RemoveButton extends React.Component {

  // Renders Component
  render() {
    return (
      <Popover
        interactionKind={PopoverInteractionKind.CLICK}
        popoverClassName="bp3-popover-content-sizing"
      >
        <Tooltip content={"Remover " + this.props.itemName} position={Position.LEFT}>
          <Button icon="remove" small intent="danger" />
        </Tooltip>
        <div style={{marginLeft: 10, marginRight: 10, backgroundColor: 'white'}}>
          <center>
            <br />
            <h5>Remover {this.props.itemName}</h5>
            <p>{this.props.confirmation}</p>
            <Button
              className={Classes.POPOVER_DISMISS}
              intent="danger"
              onClick={this.props.remove}
            >
              Remover
            </Button>
            &nbsp;&nbsp;
            <Button className={Classes.POPOVER_DISMISS}>
              Cancelar
            </Button>
            <br />
            <br />
          </center>
        </div>
      </Popover>
    );
  }
}

// Required Properties
RemoveButton.propTypes = {
  itemName: PropTypes.string.isRequired,
  confirmation: PropTypes.string.isRequired,
  remove: PropTypes.func.isRequired,
}

// Exports
export default RemoveButton;



// WEBPACK FOOTER //
// ./src/components/Common/RemoveButton.js